// src/components/ProductGrid.js
import React from 'react';
import { Row, Col, Button, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { FaEdit } from 'react-icons/fa';
import '../assets/scss/ProductGrid.scss';

const ProductGrid = ({ products, onShowDetails, onEditRack }) => {
    const isLoggedIn = !!localStorage.getItem('userToken');
    console.log(isLoggedIn);
    return (
        <Row gutter={[20, 24]} style={{ margin: 0 }}>
            {products.map(product => (
                <Col
                    key={product.item_id}
                    xs={12} sm={8} md={6} lg={6} xl={4}
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <div className="product-grid-item">
                        {isLoggedIn && onEditRack && (
                            <Tooltip title="Edit Rack">
                                <Button 
                                    icon={<FaEdit />}
                                    className="rack-edit-button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onEditRack(product);
                                    }}
                                    style={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 8,
                                        zIndex: 1,
                                        padding: '4px 8px',
                                        minWidth: 'auto',
                                        height: 'auto',
                                        borderRadius: '4px',
                                        border: 'none',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                    }}
                                />
                            </Tooltip>
                        )}
                        <div 
                            className="product-content"
                            onClick={() => onShowDetails(product)}
                            tabIndex={0}
                            role="button"
                            aria-label={`Show details for ${product.item_title}`}
                        >
                            <div className="product-image">
                                <img src={product.cover_img} alt={product.item_title} />
                            </div>
                            <div className="product-details">
                                <h5 title={product.item_title}>{product.item_title}</h5>
                                <div className="product-meta">
                                    <span className="product-id">ID: {product.item_id}</span>
                                    <span className="product-price">
                                        {typeof product.unit_price === 'number' 
                                            ? product.unit_price.toLocaleString('en-US', {style: 'currency', currency: 'LKR'})
                                            : product.unit_price}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            ))}
        </Row>
    );
};

ProductGrid.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({
        item_id: PropTypes.number.isRequired,
        item_title: PropTypes.string.isRequired,
        unit_price: PropTypes.string.isRequired,
        cover_img: PropTypes.string.isRequired
    })).isRequired,
    onShowDetails: PropTypes.func.isRequired,
    onEditRack: PropTypes.func
};

export default ProductGrid;
